export enum PrismTypes {
    key = 'key',
    case = 'case',
}
